export default __webpack_public_path__ + "static/blog-header-929115fd9ecfa069f0c22cabf2793d95.jpg";